module.exports = __webpack_public_path__ + "static/img/fidcard.24de6842.jpg";